import {inject, Injectable} from '@angular/core';
import {forkJoin, Observable} from 'rxjs';
import {DirectusService} from '@frontend/directus';
import {ParticipatingToolControllerService, TenderPhaseType} from '@frontend/shared-api';
import {ParticipatingToolsData} from '../components/table/invitation-table/invitation-table.types';

@Injectable({
  providedIn: 'root',
})
export class InvitationDataLoaderService {
  private readonly directusService = inject(DirectusService);
  private readonly participatingToolController = inject(ParticipatingToolControllerService);

  loadParticipatingToolsData(
    projectId: number,
    phase: TenderPhaseType,
  ): Observable<ParticipatingToolsData> {
    return forkJoin({
      directusHrTools: this.directusService.loadHrTools(),
      participatingToolsResponse: this.participatingToolController.getAllParticipatingTools({
        projectId,
        phase,
      }),
    });
  }
}
